'use client';

import Button from '@/app/cc/_component/ui/common/Button/Button';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/Applications/Applications.module.scss';
import { useOpenModal } from '@/app/cc/_hooks/useOpenModal';
import { sendGA } from '@/app/cc/_util/sendGA';

export default function ApplicationVisual() {
  const openModal = useOpenModal();
  return (
    <section className={styles.applicationVisual}>
      <div className={styles.inner}>
        <Text as="h3" category="title" variant="b1" color="var(--color-gray-0)">
          이실장 안심케어 서비스로
          <br />
          안전하게 보호받으세요!
        </Text>
        <Button
          type="button"
          size="xl"
          color="primary"
          variant="fill"
          className={styles.ApplicationButton}
          onClick={() => {
            sendGA('midReserveClick');
            openModal('consultation');
          }}
        >
          <Text as="span" category="heading" variant="sb2" color="var(--color-gray-0)">
            상담 신청하기
          </Text>
        </Button>
      </div>
    </section>
  );
}
